import React from 'react'
import { withStyles, createStyles, WithStyles } from '@material-ui/core/styles'
import { Size } from './Jersey'
import sizeStyles from './sizeStyles'
import emptyShirt from './assets/empty_shirt.svg'
import classNames from 'classnames'

interface Props {
  size?: Size
}

const styles = createStyles({
  ...sizeStyles
})

type InjectedProps = Props & WithStyles<typeof styles>

const JerseyPlaceholder: React.SFC<InjectedProps> = ({ size, classes, ...props }) => {
  return <img alt="" {...props} src={emptyShirt} className={classNames(classes[size as Size])} />
}

export default withStyles(styles)(JerseyPlaceholder)
